import { render } from "./LbrxErrorNotification.vue?vue&type=template&id=5ca98ef8&scoped=true"
import script from "./LbrxErrorNotification.vue?vue&type=script&lang=js"
export * from "./LbrxErrorNotification.vue?vue&type=script&lang=js"

import "./LbrxErrorNotification.vue?vue&type=style&index=0&id=5ca98ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca98ef8"]])

export default __exports__